/* L2 · Modal de reseñas reales (sustituye al widget de Judge.me en el modal) */
(function () {
  function init(root) {
    if (!root || root.dataset.l2rvInit) return;
    root.dataset.l2rvInit = '1';

    var dataEl = root.querySelector('[data-l2rv-json]');
    var dialog = root.querySelector('[data-l2rv-dialog]');
    var list = root.querySelector('[data-l2rv-list]');
    var openBtns = document.querySelectorAll('[data-l2rv-open]');
    if (!dataEl || !dialog || !list) return;

    var reviews = [];
    try { reviews = JSON.parse(dataEl.textContent.trim() || '[]'); } catch (e) { reviews = []; }

    var prodSel = root.querySelector('[data-l2rv-prod]');
    var starSel = root.querySelector('[data-l2rv-stars]');
    var search = root.querySelector('[data-l2rv-search]');
    var countEl = root.querySelector('[data-l2rv-count]');
    var emptyEl = root.querySelector('[data-l2rv-empty]');

    // build product filter options
    var prods = {};
    reviews.forEach(function (r) { if (r.product) prods[r.product] = (prods[r.product] || 0) + 1; });
    if (prodSel) {
      Object.keys(prods).sort().forEach(function (p) {
        var o = document.createElement('option');
        o.value = p; o.textContent = p + ' (' + prods[p] + ')';
        prodSel.appendChild(o);
      });
    }

    // en una ficha: preseleccionar las reseñas del producto actual (si tiene)
    function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
    var current = root.getAttribute('data-l2rv-current') || '';
    var pinned = '';
    if (prodSel && current) {
      var nc = norm(current);
      Object.keys(prods).forEach(function (p) {
        var np = norm(p);
        if (np && (nc.indexOf(np) !== -1 || np.indexOf(nc) !== -1) && np.length > norm(pinned).length) pinned = p;
      });
      if (pinned) {
        prodSel.value = pinned;
      } else {
        // el producto actual aún no tiene reseñas: lo añadimos como opción (0) y fijamos el filtro
        // en él → sale el estado vacío guiado ("Aún no hay opiniones de X · ver todas") en vez de
        // mostrar reseñas de otros productos sin avisar. (fix SimGym)
        var o0 = document.createElement('option');
        o0.value = current; o0.textContent = current + ' (0)';
        prodSel.appendChild(o0);
        prodSel.value = current;
      }
    }
    var noteEl = root.querySelector('[data-l2rv-note]');
    function syncNote() {
      if (!noteEl) return;
      if (prodSel && prodSel.value) {
        noteEl.hidden = false;
        noteEl.innerHTML = 'Mostrando opiniones de <strong>' + esc(prodSel.value) + '</strong> · <button type="button" class="l2rv-modal__seeall" data-l2rv-all>ver todas</button>';
      } else { noteEl.hidden = true; }
    }

    function stars(n) {
      n = Math.max(0, Math.min(5, n | 0));
      return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
    }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    function initial(name) { return (name || '?').trim().charAt(0).toUpperCase(); }

    function render() {
      var fp = prodSel ? prodSel.value : '';
      var fs = starSel ? parseInt(starSel.value || '0', 10) : 0;
      var fq = search ? search.value.trim().toLowerCase() : '';
      var out = reviews.filter(function (r) {
        if (fp && r.product !== fp) return false;
        if (fs && (r.rating | 0) !== fs) return false;
        if (fq) {
          var hay = ((r.body || '') + ' ' + (r.title || '') + ' ' + (r.author || '') + ' ' + (r.product || '')).toLowerCase();
          if (hay.indexOf(fq) === -1) return false;
        }
        return true;
      });
      if (countEl) countEl.textContent = out.length;
      if (emptyEl) {
        emptyEl.hidden = out.length !== 0;
        if (out.length === 0) {
          if (fp && !fs && !fq) {
            // el producto actual aún no tiene reseñas → no dejar callejón sin salida (fix SimGym)
            emptyEl.innerHTML = 'Aún no hay opiniones de <strong>' + esc(fp) + '</strong>.<br><button type="button" class="l2rv-modal__seeall" data-l2rv-all>👉 Mira las de toda la tienda</button>';
          } else {
            emptyEl.textContent = 'No hay opiniones con esos filtros.';
          }
        }
      }
      list.innerHTML = out.map(function (r) {
        return '<figure class="l2rv-card">' +
          '<div class="l2rv-card__top">' +
            '<span class="l2rv-card__stars" aria-label="' + (r.rating | 0) + ' de 5">' + stars(r.rating) + '</span>' +
            (r.product ? '<span class="l2rv-card__prod">' + esc(r.product) + '</span>' : '') +
          '</div>' +
          (r.title ? '<figcaption class="l2rv-card__title">' + esc(r.title) + '</figcaption>' : '') +
          '<blockquote class="l2rv-card__body">' + esc(r.body) + '</blockquote>' +
          '<div class="l2rv-card__who">' +
            '<span class="l2rv-card__av">' + esc(initial(r.author)) + '</span>' +
            '<span class="l2rv-card__meta"><strong>' + esc(r.author || 'Cliente') + '</strong>' +
            '<small>' + (r.verified ? '<span class="l2rv-card__check">✔ Compra verificada</span>' : '') +
            (r.date ? (r.verified ? ' · ' : '') + esc(r.date) : '') + '</small></span>' +
          '</div>' +
        '</figure>';
      }).join('');
      list.scrollTop = 0;
      syncNote();
      // si el producto actual no tiene reseñas, el estado vacío ya guía → evitar la nota redundante
      if (noteEl && out.length === 0 && fp && !fs && !fq) noteEl.hidden = true;
    }

    [prodSel, starSel].forEach(function (el) { if (el) el.addEventListener('change', render); });
    if (search) search.addEventListener('input', render);
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-l2rv-all]');
      if (b) { if (prodSel) prodSel.value = ''; render(); }
    });

    function open() {
      render();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      document.documentElement.style.overflow = '';
    }
    openBtns.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    root.querySelectorAll('[data-l2rv-close]').forEach(function (b) { b.addEventListener('click', close); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    dialog.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
  }

  function boot() { document.querySelectorAll('[data-l2rv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
